/* eslint-disable max-len */

import { Newsletter } from '../types/types';

const MOCKED_NEWSLETTERS: Newsletter[] = [
  {
    id: 1,
    name: 'Newswire',
    description:
      'A comprehensive look at the day’s top global development breaking news, analysis, and opinion',
    salesforce_id: 'n_development_newswire__c',
    frequency: 'daily',
    logo: 'https://remotive.com/web/image/hr.job/1119556/logo/64x64',
    category: 'general',
    position: 1,
    news_landing_page: {
      id: 61,
      title: 'COVID-19',
      identifier: 'covid_19',
    },
    article_access_level: null,
    permalink: 'newswire',
    accent_color: 'orange-theme',
    icon: 'bolt',
    social_image_url:
      'https://pages.devex.com/rs/685-KBL-765/images/newswire-social-promo-1200x628.png',
    campaigns: [],
    marketo_email_campaign_id: 54399,
    required_privilege: null,
    subscribed: false,
  },
  {
    id: 31,
    name: 'Devex CheckUp',
    description: 'Front-line and behind-the-scenes reporting on global health',
    salesforce_id: 'n_global_health__c',
    frequency: 'weekly',
    logo: 'https://lh4.googleusercontent.com/3Wr-ogYp2vJlJGYRqd0W_CPUp_eIauuzcGTK9uSs0KYYzuz6WXYLbAgS_kr52-uGjeUeaMboCUAaZHS2kpnkRyLMcYCttlHKUG9Dz-QI21dGXaMaH4b7zhVBFJOyljr204QwfxBz',
    category: 'general',
    position: 3,
    news_landing_page: {
      id: 64,
      title: 'Health',
      identifier: 'health',
    },
    article_access_level: null,
    permalink: 'devex-checkup',
    accent_color: 'blue-theme',
    icon: 'heartbeat',
    social_image_url:
      'https://pages.devex.com/rs/685-KBL-765/images/checkup-social-promo-1-updated.png',
    campaigns: [],
    marketo_email_campaign_id: 54393,
    required_privilege: null,
    subscribed: false,
  },
  {
    id: 33,
    name: 'Devex Invested',
    description: 'The insider brief on business, finance, and the SDGs',
    salesforce_id: 'Finance_NL__c',
    frequency: 'weekly',
    logo: 'https://pages.devex.com/rs/685-KBL-765/images/devex-invested-newsletter-sign-up-background-800x600.jpg',
    category: 'general',
    position: 4,
    news_landing_page: {
      id: 71,
      title: 'Finance',
      identifier: 'development_finance',
    },
    article_access_level: null,
    permalink: 'invested',
    accent_color: 'purple-theme',
    icon: 'donate',
    social_image_url:
      'https://pages.devex.com/rs/685-KBL-765/images/devex-invested-newsletter-signup-social-preview-1200x628.png',
    campaigns: [],
    marketo_email_campaign_id: 54398,
    required_privilege: null,
    subscribed: false,
  },
  {
    id: 36,
    name: 'Devex Dish',
    description: 'Your weekly newsletter on the transformation of the global food system',
    salesforce_id: 'Food_Systems_NL__c',
    frequency: 'weekly',
    logo: 'https://pages.devex.com/rs/685-KBL-765/images/nilotpal-kalita-pJHaHQJ0PPk-unsplash.jpg',
    category: 'general',
    position: 5,
    news_landing_page: {
      id: 74,
      title: 'Food Systems',
      identifier: 'food_systems',
    },
    article_access_level: {
      id: 5,
      name: 'Free',
    },
    permalink: 'devex-dish',
    accent_color: 'green-theme',
    icon: 'wheat',
    social_image_url:
      'https://pages.devex.com/rs/685-KBL-765/images/devex-dish-social-promo-updated.png',
    campaigns: [],
    marketo_email_campaign_id: 54394,
    required_privilege: null,
    subscribed: false,
  },
  {
    id: 6,
    name: 'Money Matters',
    description: 'Funding insights, analysis, and news, including practical business advice',
    salesforce_id: 'n_friday_wrapup__c',
    frequency: 'weekly',
    logo: 'https://pages.devex.com/rs/685-KBL-765/images/money-matters-background-image-updated-new.jpg',
    category: 'general',
    position: 6,
    news_landing_page: null,
    article_access_level: null,
    permalink: 'money-matters',
    accent_color: 'purple-theme',
    icon: 'box-usd',
    social_image_url:
      'https://pages.devex.com/rs/685-KBL-765/images/moneymatters-social-preview-1200x628.png',
    campaigns: [],
    marketo_email_campaign_id: 54397,
    required_privilege: null,
    subscribed: false,
  },
  {
    id: 8,
    name: 'Procurement Alert',
    description: 'The latest international development procurement and grant opportunities',
    salesforce_id: 'n_procurement_alert__c',
    frequency: 'daily',
    logo: 'https://res.cloudinary.com/devex/image/asset/bg-step-pm-e41c075aecad45409ff60e6591d049e3.jpg',
    category: 'general',
    position: 7,
    news_landing_page: null,
    article_access_level: null,
    permalink: 'procurement-alert',
    accent_color: 'orange-dark-theme',
    icon: 'alarm-clock',
    social_image_url: '',
    campaigns: [],
    marketo_email_campaign_id: 54396,
    required_privilege: null,
    subscribed: false,
  },
  {
    id: 7,
    name: 'Devex Career Hub',
    description:
      'Global development jobs, expert career advice, and practical tools to help you do more good',
    salesforce_id: 'n_weekly_jobs__c',
    frequency: 'weekly',
    logo: 'https://pages.devex.com/rs/685-KBL-765/images/devex-career-hub-subscribe-page-background.jpg',
    category: 'general',
    position: 8,
    news_landing_page: null,
    article_access_level: {
      id: 5,
      name: 'Free',
    },
    permalink: 'devex-career-hub',
    accent_color: 'blue-theme',
    icon: 'chart-network',
    social_image_url:
      'https://pages.devex.com/rs/685-KBL-765/images/devex-career-hub-promo-1200x628.png',
    campaigns: [],
    marketo_email_campaign_id: 54395,
    required_privilege: null,
    subscribed: false,
  },
  {
    id: 20,
    name: 'Weekender',
    description: 'For Pro members only. Insider commentary and a look at the week ahead.',
    salesforce_id: 'Weekender_NL_unsubscribe__c',
    frequency: 'weekly',
    logo: 'https://res.cloudinary.com/devex/image/asset/membership-landing-1346610aa8285d7082f14e5af2763b0b.jpg',
    category: 'general',
    position: 9,
    news_landing_page: null,
    article_access_level: {
      id: 7,
      name: 'Pro Membership',
    },
    permalink: 'weekender',
    accent_color: 'aqua-theme',
    icon: 'clipboard-list-check',
    social_image_url: '',
    campaigns: [],
    marketo_email_campaign_id: null,
    required_privilege: {
      id: 76,
      name: 'Subscribe to Weekender',
      constant_name: 'SUBSCRIBE_TO_WEEKENDER',
      credit_check: false,
      description: 'Can subscribe to the Weekender newsletter',
    },
    subscribed: false,
  },

  {
    id: 22,
    name: 'Focus on: Faith and Development',
    description:
      'This focus area, powered by GHR Foundation, illuminates the role faith actors and their communities play in strengthening global development outcomes.',
    salesforce_id: 'Focus_On_Faith__c',
    frequency: 'monthly',
    logo: 'https://pages.devex.com/rs/685-KBL-765/images/headeropt3_faith.jpg',
    category: 'focus_areas',
    position: 15,
    news_landing_page: {
      id: 62,
      title: 'Focus on: Faith and Development',
      identifier: 'faith_development',
    },
    article_access_level: null,
    permalink: 'focus-on-faith-and-development',
    accent_color: 'green-dark-theme',
    icon: 'globe',
    social_image_url: '',
    campaigns: [],
    marketo_email_campaign_id: null,
    required_privilege: null,
    subscribed: false,
  },
];

export { MOCKED_NEWSLETTERS };
